import i18n from "@/i18n";
import { IMenuRoute } from "@/models/routes";

export function affiliateAccountTabigation(): IMenuRoute[] {
  return [
    {
      label: i18n.t("_.overview"),
      to: { name: "adminClientAffiliateOverview" }
    },
    {
      label: i18n.t("_.commissions"),
      to: { name: "adminClientAffiliateCommissions" }
    },
    {
      label: i18n.t("_.payouts"),
      to: { name: "adminClientAffiliatePayouts" }
    },
    {
      label: i18n.t("_.settings"),
      to: { name: "adminClientAffiliateSettings" }
    }
  ];
}
